import React from 'react';
import _ from 'lodash';
import '../../lib/LodashMixins';

export default function CheckboxInputControlled(props) {
    const hasError = !_.isEmpty(props.errorMessage);
    const noWrapper = _.stringToBoolean(props.noWrapper);
    const wrapperStyle = noWrapper
        ? { display: 'inline' }
        : { paddingBottom: '2px', display: 'flex', alignItems: 'center' };

    const classChecked = _.stringToBoolean(props.value) ? 'form-checkbox-checked' : '';
    const classType = hasError ? 'form-checkbox-error' : '';

    const checkboxClickHandler = (event) => {
        if (!props.disabled && props.changed) {
            props.changed(props.id, !_.stringToBoolean(props.value));
        }
    };

    return (
        <div
            className="custom-checkbox-input"
            style={wrapperStyle}
            onClick={checkboxClickHandler}
        >
            <label className={`form-checkbox ${classType} ${classChecked}`}>
                <input id={props.id} type="hidden" value={props.value} />
                <span
                    className="glyphicon glyphicon-ok"
                    style={{ opacity: _.stringToBoolean(props.value) ? 1 : 0 }}
                ></span>
            </label>
            <span style={{ marginLeft: '7px', fontWeight: 'bold', cursor: 'default' }}>
                {props.labelText}
            </span>
        </div>
    );
}
